import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { EntityPermissionGuard, AskToDeactivateGuard } from '@kpd/framework-ngx';
import { titleFunction } from 'app/app-routing.module';
import { PermissionsLayoutComponent } from './overview/layout/permissions-layout.component';
import { PermissionDetailsComponent } from './detail/permission-details.component';
import { EntityResolverTypes } from 'app/app.entity.resolvers';

const permissionsRoutes: Routes = [
  {
    path: 'permissions',
    component: PermissionsLayoutComponent,
    data: {
      routeName: 'permissions',
      routePermissionPrefix: 'Permission',
      breadCrumbData: { titleFunc: titleFunction('Permissions') },
    },
    canActivate: [EntityPermissionGuard],
    canDeactivate: [AskToDeactivateGuard],
  },
  {
    path: 'permissions/details/:id',
    component: PermissionDetailsComponent,
    data: {
      routeName: 'permissionDetail',
      routeParentName: 'permissions',
      routePermissionPrefix: 'Permission',
      routePermissionPrefixTabs: { users: 'User.Manage', permissionSets: 'User.Manage', roles: 'User.Manage' },
      routePermissionId: 'id',
      breadCrumbData: {
        titleResolverType: EntityResolverTypes.permission,
        titleEntityIdKeys: 'id',
      },
      pageTitlePrefixFunc: titleFunction('Permission'),
    },
    canActivate: [EntityPermissionGuard],
    canDeactivate: [AskToDeactivateGuard],
    runGuardsAndResolvers: 'always',
  },
];

@NgModule({
  imports: [RouterModule.forChild(permissionsRoutes)],
  exports: [RouterModule],
})
export class PermissionsRoutingModule {}
